var Acr = Acr || {};

Acr.CarouselText = function () {
  var $carouselText;
  var $carouselTextSwiperContainer;
  var $carouselNavigationItems;
  var $swiperPagination;
  var $sliderShadow;
  var $arrowLeft;
  var $arrowRight;
  var carouselTextSwiper;
  var matchMedia;
  const swiperContainerSelector = '.js-swiper-container';
  const swiperPaginationSelector = '.js-swiper-pagination';
  const arrowLeftSelector = '.js-arrow-left';
  const arrowRightSelector = '.js-arrow-right';
  const navigationItemSelector = '.js-carousel-text-nav-item';
  const sliderShadowSelector = '.js-slider-shadow';
  const navItemActiveClass = 'acr-carousel-text__nav-item--active';

  // Initialize all HTML selectors
  function initSelectors(element) {
    $carouselText = element;
    $carouselTextSwiperContainer = $carouselText.querySelector(swiperContainerSelector);
    $carouselNavigationItems = $carouselText.querySelectorAll(navigationItemSelector);
    $swiperPagination = $carouselText.querySelector(swiperPaginationSelector);
    $sliderShadow = $carouselText.querySelector(sliderShadowSelector);
    $arrowLeft = $carouselText.querySelector(arrowLeftSelector);
    $arrowRight = $carouselText.querySelector(arrowRightSelector);
  }

  // Initialize all necessary global variables in the component
  function initGlobalVariables() {
    matchMedia = window.matchMedia('(min-width: ' + (Constants.breakpoints.lg) + 'px)');
  }

  // Initialize the swiper slider for the carouse-text
  function initCarouseTextSliderSwiper() {
    carouselTextSwiper = new Swiper($carouselTextSwiperContainer, {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: $swiperPagination,
        clickable: true,
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft,
      },
      init: true,
    });

    // Every time the slide changes, the navigation item outside the carousel are updated (if the navigation item are available)
    carouselTextSwiper.on('slideChange', function () {
      var swiperIndex = carouselTextSwiper.realIndex;
      updateNavigationItems(swiperIndex);

      if (Acr.TrackingManager) {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, carouselTextSwiper);
      }
    });
  }

  // Update the navigation item for the carousel text when the slide changes.
  function updateNavigationItems(swiperIndex) {
    $carouselNavigationItems.forEach(function (item) {
      var itemIndex = parseInt(item.getAttribute('data-slide-index'), 10);
      if (swiperIndex === itemIndex) {
        item.classList.add(navItemActiveClass);
      } else {
        item.classList.remove(navItemActiveClass);
      }
    });
  }

  function bindEvents() {
    // Events only for Desktop size
    if (Utility.isDesktop()) {
      assignNavigationItemsClickEvent();

      $arrowLeft.addEventListener('mouseover', showArrowShadow);
      $arrowRight.addEventListener('mouseover', showArrowShadow);
      $arrowLeft.addEventListener('mouseout', hideArrowShadow);
      $arrowRight.addEventListener('mouseout', hideArrowShadow);
      $arrowLeft.addEventListener('click', hideArrowShadow);
      $arrowRight.addEventListener('click', hideArrowShadow);
    }

    // Using matchMedia to check if it is desktop size, to avoid window.resize
    matchMedia.addListener(matchMediaHandler);
  }

  // If it is desktop size, add the click events to each navigation item, otherwise delete the click event
  function matchMediaHandler() {
    if (matchMedia.matches) {
      assignNavigationItemsClickEvent();

      $arrowLeft.addEventListener('mouseover', showArrowShadow);
      $arrowRight.addEventListener('mouseover', showArrowShadow);
      $arrowLeft.addEventListener('mouseout', hideArrowShadow);
      $arrowRight.addEventListener('mouseout', hideArrowShadow);
      $arrowLeft.addEventListener('click', hideArrowShadow);
      $arrowRight.addEventListener('click', hideArrowShadow);

    } else {
      $carouselNavigationItems.forEach(function (item) {
        item.removeEventListener('click', changeSwiperSlide);
      });

      $arrowLeft.removeEventListener('mouseover', showArrowShadow);
      $arrowRight.removeEventListener('mouseover', showArrowShadow);
      $arrowLeft.removeEventListener('mouseout', hideArrowShadow);
      $arrowRight.removeEventListener('mouseout', hideArrowShadow);
      $arrowLeft.removeEventListener('click', hideArrowShadow);
      $arrowRight.removeEventListener('click', hideArrowShadow);
    }
  }

  // Attachment of click events for each navigation item
  function assignNavigationItemsClickEvent() {
    $carouselNavigationItems.forEach(function (item) {
      item.addEventListener('click', changeSwiperSlide);
    });
  }

  // Switch to the swiper slide related to the item that was clicked, using the index of both elements
  function changeSwiperSlide() {
    event.preventDefault();
    var slideIndex = parseInt(this.getAttribute('data-slide-index'), 10);
    $carouselNavigationItems.forEach(function (item) {
      item.classList.remove(navItemActiveClass);
    });
    this.classList.add(navItemActiveClass);
    carouselTextSwiper.slideToLoop(slideIndex);
  }

  // Show arrow shadows when arrows hover
  function showArrowShadow() {
    $sliderShadow.style.zIndex = '2';
    $sliderShadow.style.opacity = '0.6';
  }

  // Hide arrow shadows when arrows hover
  function hideArrowShadow() {
    $sliderShadow.style.removeProperty('opacity');
    setTimeout(function () {
      $sliderShadow.style.removeProperty('z-index');
    }, 300);
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    initCarouseTextSliderSwiper();
    bindEvents();
  }

  return {
    init: init,
  };
};
